import { Record } from '../types/records';

const LOCAL_STORAGE_KEY = 'seyhot_records';

const getRecordsFromStorage = (): Record[] => {
  try {
    const rawData = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!rawData) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([]));
      return [];
    }
    const parsed = JSON.parse(rawData);
    return parsed.map((record: any) => ({
      ...record,
      startDate: record.startDate ? new Date(record.startDate) : undefined,
      endDate: record.endDate ? new Date(record.endDate) : undefined,
      lastUpdated: new Date(record.lastUpdated),
    }));
  } catch (error) {
    console.error("localStorage'dan kayıtları okuma hatası", error);
    return [];
  }
};

const saveRecordsToStorage = (records: Record[]): void => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(records));
  } catch (error) {
    console.error("localStorage'a kayıtları yazma hatası", error);
  }
};

export const getRecords = (): Record[] => {
  return getRecordsFromStorage();
};

export const addRecord = (newRecord: Partial<Record>): Record => {
    // DEBUG: Servise gelen veriyi göster
    console.log("addRecord servisi çağrıldı, gelen veri:", newRecord);

    const records = getRecordsFromStorage();
    
    const recordToAdd: Record = {
        id: newRecord.id || `rec_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        cityCode: newRecord.cityCode || 0,
        cityName: newRecord.cityName || '',
        districtName: newRecord.districtName,
        category: newRecord.category || 'Etkinlikler',
        status: newRecord.status || 'AÇIK',
        title: newRecord.title || 'Başlıksız Kayıt',
        summary: newRecord.summary || '',
        content: newRecord.content || '',
        coverImage: newRecord.coverImage || '',
        galleryImages: newRecord.galleryImages || [],
        startDate: newRecord.startDate,
        endDate: newRecord.endDate,
        lastUpdated: new Date(),
        venueName: newRecord.venueName,
        coordinates: newRecord.coordinates,
        priceType: newRecord.priceType || 'Ücretsiz',
        sourceType: newRecord.sourceType || 'Topluluk',
        isFeatured: newRecord.isFeatured || false,
        viewsLast7Days: 0,
        savesLast7Days: 0,
    };

    // DEBUG: Kaydedilecek son halini göster
    console.log("addRecord içinde, localStorage'a yazılacak son obje:", recordToAdd);

    const updatedRecords = [...records, recordToAdd];
    saveRecordsToStorage(updatedRecords);
    return recordToAdd;
};

export const getRecordById = (id: string): Record | undefined => {
  const records = getRecordsFromStorage();
  return records.find(record => record.id === id);
};

export const updateRecord = (updatedRecordData: Partial<Record>): Record | undefined => {
    // DEBUG: Servise gelen veriyi göster
    console.log("updateRecord servisi çağrıldı, gelen veri:", updatedRecordData);

    if (!updatedRecordData.id) {
        console.error("Güncelleme başarısız: Kayıt ID'si eksik.");
        return undefined;
    }
    const records = getRecordsFromStorage();
    let recordToUpdate: Record | undefined;
    
    const updatedRecords = records.map(record => {
        if (record.id === updatedRecordData.id) {
            const newRecordData = { ...record, ...updatedRecordData };

            recordToUpdate = {
                ...newRecordData,
                content: updatedRecordData.content ?? record.content,
                coverImage: updatedRecordData.coverImage ?? record.coverImage,
                galleryImages: updatedRecordData.galleryImages ?? record.galleryImages,
                lastUpdated: new Date(),
            };
            return recordToUpdate;
        }
        return record;
    });

    if (recordToUpdate) {
        // DEBUG: Güncellenecek son halini göster
        console.log("updateRecord içinde, localStorage'a yazılacak son obje:", recordToUpdate);
        saveRecordsToStorage(updatedRecords);
    } else {
        console.warn(`Güncellenecek kayıt bulunamadı: ID ${updatedRecordData.id}`);
    }
    
    return recordToUpdate;
};

export const deleteRecord = (id: string): void => {
    const records = getRecordsFromStorage();
    const updatedRecords = records.filter(record => record.id !== id);
    saveRecordsToStorage(updatedRecords);
};
